import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../layout'


/**
 * Note: 子菜单只在路由子菜单时出现。长度> = 1
 * hidden: true                  如果设置为true，项目将不会显示在侧栏中(默认为false)
 * alwaysShow: true              如果设置为true，将始终显示根菜单
 *                               如果不设置总是显示，当项目有多个子路由时
 *                               它将成为嵌套模式，否则不显示根菜单
 * redirect: noRedirect          如果设置noRedirect，则不会在面包屑中重定向
 * name:'router-name'            名称由(必须设置!!)使用
 * meta : {
    roles: ['admin','editor']    控制页面角色(可以设置多个角色)
    title: 'title'               名称显示在侧边栏和面包屑(推荐)
    icon: 'svg-name'             图标显示在侧栏中
    noCache: true                如果设置为true，页面将不会被缓存,是否头部添加删除按钮(默认为false)
    affix: true                  如果设置为true，则标记将附加在标记视图中
    breadcrumb: false            如果设置为false，则该项将隐藏在breadcrumb中(默认为true)
    activeMenu: '/example/list'  如果设置路径，侧栏将突出显示您设置的路径
*/
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path*',
                component: () => import('@/views/redirect/index')
            }
        ]
    },
    {
        path: '/login',
        component: () => import('../views/login/index'),
        name: 'login',
        hidden: true,
        meta: {title: '登录'}
    },
    {
      path: '/login-passwd',
      component: () => import('../views/login/passwd.vue'),
      name: 'login-passwd',
      hidden: true,
      meta: {title: '登录'}
    },
    {
        path: '/auth-redirect',
        component: () => import('@/views/login/auth-redirect'),
        hidden: true
    },
    {
        path: '/404',
        component: () => import('@/views/error-page/404'),
        hidden: true
    },
    {
        path: '/401',
        component: () => import('@/views/error-page/401'),
        hidden: true
    },
    // 首页
    {
        path: '/',
        component: Layout,
        redirect: '/employee/users',
        // children: [
        //     {
        //         path: 'homePage',
        //         component: () => import('../views/dashboard/index'),
        //         name: 'homePage',
        //         meta: {title: '首页', icon: 'dashboard', affix: true}
        //     }
        // ]
    },
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [

    // 系统管理
    {
        path: '/employee',
        component: Layout,
        redirect: '/employee/importUser',
        alwaysShow: true, // will always show the root menu
        name: 'employee',
        meta: {
            title: '员工管理',
            icon: 'lock',
            roles: ['admin', 'editor'] // you can set roles in root nav
        },
        children: [
            {
              path: 'users',
              component: () => import('../views/711/users'),
              name: 'users',
              meta: {
                title: '员工信息',
                roles: ['admin', 'editor'], // or you can only set roles in sub nav
              },
            },
            {
                path: 'importUser',
                component: () => import('../views/711/importUser'),
                name: 'importUser',
                meta: {
                    title: '员工信息导入',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            }
        ]
    },
    // 系统管理
    {
        path: '/system',
        component: Layout,
        redirect: '/system/userIndex',
        alwaysShow: true, // will always show the root menu
        name: 'system',
        meta: {
            title: '系统管理',
            icon: 'lock',
            roles: ['admin', 'editor'] // you can set roles in root nav
        },
        children: [
            {
                path: 'userIndex',
                component: () => import('../views/system/userIndex'),
                name: 'userIndex',
                meta: {
                    title: '用户管理',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
            {
                path: 'passwordManagement',
                component: () => import('../views/system/passwordManagement'),
                name: 'passwordManagement',
                meta: {
                    title: '密码管理',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
            {
                path: 'role',
                component: () => import('../views/system/role'),
                name: 'role',
                meta: {
                    title: '角色管理',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
            {
                path: 'systemMenu',
                component: () => import('../views/system/systemMenu'),
                name: 'systemMenu',
                meta: {
                    title: '系统菜单',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
            {
                path: 'department',
                component: () => import('../views/system/department'),
                name: 'department',
                meta: {
                    title: '部门管理',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
        ]
    },
    // 系统监控
    {
        path: '/monitoring',
        component: Layout,
        redirect: '/monitoring/notes',
        alwaysShow: true, // will always show the root menu
        name: 'monitoring',
        meta: {
            title: '系统监控',
            icon: 'lock',
            roles: ['admin', 'editor'] // you can set roles in root nav
        },
        children: [
            {
                path: 'notes',
                component: () => import('../views/monitoring/notes'),
                name: 'notes',
                meta: {
                    title: '在线用户',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
            {
                path: 'online',
                component: () => import('../views/monitoring/online'),
                name: 'online',
                meta: {
                    title: '系统日志',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
            {
                path: 'runMonitoring',
                component: () => import('../views/monitoring/runMonitoring'),
                name: 'runMonitoring',
                meta: {
                    title: '运行监控',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
        ]
    },
    // 基础管理
    {
        path: '/basis',
        component: Layout,
        redirect: '/basis/basisData',
        alwaysShow: true, // will always show the root menu
        name: 'basis',
        meta: {
            title: '基础管理',
            icon: 'lock',
            roles: ['admin', 'editor'] // you can set roles in root nav
        },
        children: [
            {
                path: 'basisData',
                component: () => import('../views/basis/basisData'),
                name: 'basisData',
                meta: {
                    title: '数据字典',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
            {
                path: 'fileManagement',
                component: () => import('../views/basis/fileManagement'),
                name: 'fileManagement',
                meta: {
                    title: '文件管理',
                    roles: ['admin', 'editor'] // or you can only set roles in sub nav
                }
            },
        ]
    },
    {path: '*', redirect: '/404', hidden: true}
]

const createRouter = () => new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
